import { useState, useEffect, useRef, useCallback } from 'react';
import { BASE_WS_URL } from '../config/config';

export default function useMatch() {
  const [matchData, setMatchData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const wsRef = useRef(null);
  const reconnectTimerRef = useRef(null);
  const reconnectAttempts = useRef(0);
  const MAX_RECONNECT_ATTEMPTS = 5;
  const RECONNECT_DELAY = 3000; // 3 seconds

  const connect = useCallback(() => {
    // Clean up existing connection
    if (wsRef.current) {
      wsRef.current.close();
    }

    const ws = new WebSocket(`${BASE_WS_URL}/sports`);
    wsRef.current = ws;

    ws.onopen = () => {
      reconnectAttempts.current = 0; 
      setError(null);
    };

    ws.onmessage = (event) => {
      const data = JSON.parse(event.data);
      setMatchData(data);
      setLoading(false);
    };

    ws.onerror = () => {
      setError('Failed to connect to match feed');
      setLoading(false);
    };

    ws.onclose = () => {
      // Auto-reconnect with limit
      if (reconnectAttempts.current < MAX_RECONNECT_ATTEMPTS) {
        reconnectAttempts.current += 1;
        reconnectTimerRef.current = setTimeout(() => {
          connect();
        }, RECONNECT_DELAY);
      } else {
        setError('Connection lost. Max reconnect attempts reached.');
      }
    };
  }, []);

  useEffect(() => {
    connect();

    return () => {
      clearTimeout(reconnectTimerRef.current);
      wsRef.current?.close();
    };
  }, [connect]);


  const reconnect = () => {
    reconnectAttempts.current = 0;
    connect();
  };

  return { matchData, error, loading, reconnect };
}